/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  Divider,
  TextField,
  Button,
  Grid,
  FormControlLabel, Checkbox,
  List, ListSubheader, ListItem, ListItemText, ListItemSecondaryAction
} from "@material-ui/core";

import { ArrowRight, ArrowRightAlt } from '@material-ui/icons'
import Actions from "../../../fluid/Actions/ActionFactory";

import FDropDown from "../../../fluid/Elements/Inputs/FDropDown";

import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";

import ChipInput from "material-ui-chip-input";

const clone = require("rfdc")();

const styles = (theme) => ({
  input: {
    margin: 0,
    padding: 0,
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const new_field = {
  name: "",
  base: [],
  attachments: [],
};

class ConfigureWV extends Component {
  state = {
    fields: [],
    device_fields: [],
    file_types: [],
    wv_fields: [],
    selected_wv_field : null,
    selected_raw_field : null,
    submit: false,
    error: false,
    error_text: "",
  };

  componentWillMount() {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        this.props.iu_name +
        "/field_in_scope",
      method: "get",
      data: {},
    })
      .then((res) => {
        let device_fields = res.data.result.map((item) => {
          let field_object = {
            include_field_level_attachment: false,
            include_file_extensions: [],
            include_value_with_embedded_attachment: false,
            name: item.name
          }
          return field_object
        });
        this.setState({ ...this.state, device_fields: device_fields }, () =>
          console.log("WV State: ", this.state)
        );
        this.generateFields();
      })
      .catch((err) => {
        this.handleError(err, "Error while fetching fields in scope.");
      });

    Actions("http_request", {
      url: "/sainapse/file_types",
      method: "get",
      data: {},
    })
      .then((res) => {
        let file_types = res.data.result.map(file_type => file_type.type);

        this.setState({ ...this.state, file_types: file_types }, () =>
          console.log("WV State: ", this.state)
        );
        this.generateFields();
      })
      .catch((err) => {
        this.handleError(err, "Error while fetching file types.");
      });
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.submit === false) {
      var equal = require('deep-equal')
      if (!equal(prevState.fields, this.state.fields)) {
        console.log("Case Screen :: Handling Next : ", this.state.fields)
        this.props.handleNext(this.state.fields)
      }
    }
  }

  handleError = (err, genericMsg) => {
    let errorMessage;
    if (err.response) {
      let response = err.response.data;

      if (err.response.status === 404) {
        errorMessage = response.message || "Resource not found.";
      } else {
        if (response) {
          if (Array.isArray(response.errors)) {
            response.errors.forEach((errObj) => {
              errorMessage = errorMessage.concat(errObj.message);
            });
          } else if (response.message) {
            errorMessage = response.message;
          } else {
            errorMessage = genericMsg;
          }
        }
      }
    }
    this.setState({
      error: true,
      error_text: errorMessage,
    });
  };

  handleWVFieldUpdate = (index, value) => {
    let new_state = clone(this.state);

    new_state.fields[index].name = value;
    this.setState({ ...new_state });
  };

  handleChipChange = (field, index, value) => {
    console.log("New Value: ", value);
    let new_state = clone(this.state);

    let new_value = value.map((val) => {
      if (field === "base") {
        return val.name;
      } else {
        return val.annotation;
      }
    });
    new_state.fields[index][field] = new_value;
    this.setState({ ...new_state }, () =>
      console.log("Configure WV State: ", this.state)
    );
  };

  validateEntry = (value, data_set) => {
    if (data_set.includes(value)) {
      return true;
    } else {
      return false;
    }
  };

  generateFields = () => {
    let fields = [];
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.wv_ic_name +
        "/world_view_fields",
      method: "get",
      data: {},
    })
      .then((res) => {
        fields = res.data.result.map((item) => {
          let new_field = {
            name: item.name,
            base: [],
            record_level_attachment_filters: {
              allowed_file_extensions : [],
              attachment_enabled : false
            },
          };

          return new_field;
        });

        this.setState({ ...this.state, fields: fields });
      })
      .catch((err) => {
        this.handleError(err, "Error while fetching world view fields.");
      });
  };

  renderFields = () => {
    const { classes } = this.props;
    let fields = this.state.fields.map((field, index) => {
      return (
        <Grid item xs={6}>
          <ThemeProvider>
            <Paper
              style={{ margin: "5px", padding: "10px" }}
              elevation={2}
              square
            >
              <Grid container spacing={1} xs={12} direction="row">
                <Grid item xs={12}>
                  <Typography variant="overline">World View Field:</Typography>
                  <Typography display="inline" variant="subtitle2">
                    {" "}
                    {field.name}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1} xs={12} direction="column">
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    id="tags-standard"
                    options={this.state.device_fields}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, newValue) => {
                      this.handleChipChange("base", index, newValue);
                    }}
                    // onChange = {(event, newValue) => console.log('New Value: ', newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Base"
                        size="small"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    id="tags-standard"
                    options={this.state.file_types}
                    getOptionLabel={(option) => option.type}
                    onChange={(event, newValue) => {
                      this.handleChipChange("attachments", index, newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="Attachment"
                        size="small"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </ThemeProvider>
        </Grid>
      );
    });
    return fields;
  };

  addField = () => {
    let new_state = clone(this.state);

    new_state.fields.push({
      name: "",
      base: [],
      attachments: [],
    });

    this.setState({ ...new_state });
  };

  removeField = () => {
    let new_state = clone(this.state);

    new_state.fields.pop();

    this.setState({ ...new_state });
  };

  submitWorldViewMap = () => {
      Actions("http_request", {
        url:
          "/sainapse/information_channel/" +
          this.props.ic_name +
          "/information_unit/" +
          this.props.iu_name +
          "/world_view",
        method: "post",
        data: {
          world_view_fields: this.state.fields,
        },
      })
      .then((res) => {
        console.log("Post WV Map Submit: ", res.data);
        this.props.handleNext();
      })
      .catch((err) => {
        this.handleError(err, "Error submitting world view fields.");
      });
  };

  renderWorldViewList = () => {
    return (
      <Paper 
        square
        elevation = {0}
        style = {{
          width : '25%',
          height : '100%',
          borderRight : '1px solid rgba(0,0,0,0.12)',
          borderBottom : '1px solid rgba(0,0,0,0.12)'
        }}
      >
        <List subheader={<ListSubheader>World View Fields</ListSubheader>}>
          <Divider/>
          {this.state.fields.map(wv_field => {
            let selected = this.state.selected_wv_field === wv_field.name
            return (
              <Fragment>
                <ListItem 
                  button 
                  selected = {selected}
                  onClick = {() => this.setState({...this.state, selected_wv_field : wv_field.name, selected_raw_field : null})}>
                  <ListItemText id = {wv_field.name} primary = {<Typography variant = {selected ? 'subtitle2' : 'body2'}>{wv_field.name}</Typography>} />
                  <ListItemSecondaryAction>
                    <ArrowRight style = {{color : selected ? "#2296f3" : "rgba(0,0,0,0.12)"}} />
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider/>
              </Fragment>
            )
          })}
        </List>
      </Paper>
    )
  }

  getMappedFields = () => {
    let wv_field_object = this.state.fields.find(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_object) {
      let mapped_fields = wv_field_object.base
      return mapped_fields
    } else {
      return []
    }

  }

  mapFieldsToWV = (fields) => {
    let new_state = clone(this.state);
    let wv_field_index = new_state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_index !== -1) {
      new_state.fields[wv_field_index].base = fields
      if (new_state.selected_raw_field !== null) {
        let raw_field_index = new_state.fields[wv_field_index].base.findIndex(raw_field => raw_field.name === new_state.selected_raw_field)
        if (raw_field_index === -1) {
          new_state.selected_raw_field = null
        }
      }
    }
    this.setState({...new_state}, () => console.log("Maping Fields to WV :", this.state))
  }

  getGlobalAttachmentState = () => {
    let wv_field_object = this.state.fields.find(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_object) {
      return wv_field_object.record_level_attachment_filters.attachment_enabled
    }
  }

  setGlobalAttachmentState = (checked) => {
    let new_state = clone(this.state);
    let wv_field_index = new_state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_index !== -1) {
      new_state.fields[wv_field_index].record_level_attachment_filters.attachment_enabled = checked
      if (checked === false) {
        new_state.fields[wv_field_index].record_level_attachment_filters.allowed_file_extensions = []
      }
    }
    this.setState({...new_state}, () => console.log("Maping Fields to WV :", this.state))
  }

  getGlobalAttachmentFileTypes = () => {
    let wv_field_index = this.state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_index !== -1) {
      return this.state.fields[wv_field_index].record_level_attachment_filters.allowed_file_extensions
    } else {
      return []
    }
  }

  setGlobalAttachmentFileTypes = (file_types) => {
    let new_state = clone(this.state);
    let wv_field_index = new_state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_index !== -1) {
      new_state.fields[wv_field_index].record_level_attachment_filters.allowed_file_extensions = file_types
    }
    this.setState({...new_state}, () => console.log("Maping Fields to WV :", this.state))
  }

  getMappedFields = () => {
    let wv_field_index = this.state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    return this.state.fields[wv_field_index].base
  }

  renderMapArea = () => {
    return (
      <div
        style = {{
          width : '75%',
          height : '100%',
          backgroundColor : '#FFFFFF',
          display : 'flex',
          flexDirection : 'column',
          borderBottom : '1px solid rgba(0,0,0,0.12)'
        }}
      >
        <List subheader={<ListSubheader>Map Fields in scope and attachments to world view field.</ListSubheader>}>
          <Divider/>
        </List>
        <div
          style = {{
            width : '100%',
            display : 'flex',
            flexDirection : 'row',
            justifyContent : 'center',
            alignItems : 'center',
            borderBottom : '1px solid rgba(0,0,0,0.12)',
            padding : '20px',
            overflow : 'auto'
          }}
        >
          <div style = {{flexGrow : 1}}>
            <Autocomplete
              fullWidth
              multiple
              id="tags-standard"
              options={this.state.device_fields}
              getOptionLabel={(option) => option.name}
              value = {this.getMappedFields()}
              onChange = {(event, newValue) => this.mapFieldsToWV(newValue)}
              ChipProps = {{size : 'small'}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label="Fields In Scope"
                  size="small"
                  helperText = "Select the fields to be mapped"
                />
              )}
            />
          </div>
          <div style = {{width : '20%', display : 'flex', flexDirection : 'row', alignItems: 'center', justifyContent : 'center'}}>
            <ArrowRightAlt style = {{fontSize : '35', color : "#2296f3"}} />
          </div>
          <div style = {{width : '40%'}}>
            <Typography display = 'block' variant = 'h6'>{this.state.selected_wv_field}</Typography>
            <Typography display = 'block' variant = 'caption' color = 'textSecondary'>World View Field</Typography>
          </div>
        </div>
        <div
          style = {{
            width : '100%'
          }}
        >
          <Typography style = {{margin: '10px'}} variant = 'subtitle2' color = 'primary'>Record Level Attachments</Typography>
          <div
            style = {{
              width : '100%',
              display : 'flex',
              flexDirection : 'row',
              alignItems : 'center',
              borderBottom : '1px solid rgba(0,0,0,0.12)',
              padding : '10px'
            }}
          >
            <div style = {{flexGrow : 1}}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked = {this.getGlobalAttachmentState()}
                    name="checkedB"
                    color="primary"
                    onChange = {(event) => this.setGlobalAttachmentState(event.target.checked)}
                  />
                }
                label = "Include Global Attachments"
                labelPlacement = "start"
              />
            </div>
            <div style = {{width : '60%'}}>
              <Autocomplete
                multiple
                id="tags-standard"
                options={this.state.file_types}
                getOptionLabel={(option) => option}
                value = {this.getGlobalAttachmentFileTypes()}
                disabled = {!this.getGlobalAttachmentState()}
                onChange={(event, newValue) => {
                  this.setGlobalAttachmentFileTypes(newValue)
                }}
                ChipProps = {{size : 'small'}}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="File Types"
                    size="small"
                    helperText = "Accepted File Types. If nothing is selected, all supported file types will be processed."
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'column'}}>
            <div style = {{borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
              <Typography style = {{margin: '10px'}} variant = 'subtitle2' color = 'primary'>Field Level Attachments</Typography> 
            </div>
            <div
              style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'row'}}
            >
              <div
                style = {{width : '40%', height : '100%', overflow : 'auto', borderRight : '1px solid rgba(0,0,0,0.12)'}}
              >
                <List subheader={<ListSubheader>Mapped Fields</ListSubheader>}>
                  <Divider/>
                  {this.getMappedFields().map(raw_field => {
                    let selected = this.state.selected_raw_field === raw_field.name
                    return (
                      <Fragment>
                        <ListItem 
                          button 
                          selected = {selected}
                          onClick = {() => this.setState({...this.state, selected_raw_field : raw_field.name})}
                        >
                          <ListItemText 
                            id = {raw_field.name} 
                            primary = {<Typography variant = {selected ? 'subtitle2' : 'body2'}>{raw_field.name}</Typography>}
                          />
                          {/* <ListItemSecondaryAction>
                            <ArrowRight style = {{color : selected ? "#2296f3" : "rgba(0,0,0,0.12)"}} />
                          </ListItemSecondaryAction> */}
                        </ListItem>
                        <Divider/>
                      </Fragment>
                    )
                  })}
                </List>
              </div>
              <div style = {{width : '100%', padding : '10px'}}>
                  {this.state.selected_raw_field !== null && this.renderFieldAttachmentSettings()}
              </div>
            </div>
        </div>
      </div>
    )
  }

  getFieldProperty = (wv_field, raw_field, property) => {
    let wv_field_index = this.state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_index !== -1) {
      let raw_field_index = this.state.fields[wv_field_index].base.findIndex(raw_field => raw_field.name === this.state.selected_raw_field)
      if (raw_field_index !== -1) {
        let property_value = this.state.fields[wv_field_index].base[raw_field_index][property]
        return property_value
      }
    }
  }

  setFieldProperty = (wv_field, raw_field, property, value) => {
    let new_state = clone(this.state);
    let wv_field_index = new_state.fields.findIndex(wv_field => wv_field.name === this.state.selected_wv_field)
    if (wv_field_index !== -1) {
      let raw_field_index = new_state.fields[wv_field_index].base.findIndex(raw_field => raw_field.name === this.state.selected_raw_field)
      if (raw_field_index !== -1) {
        new_state.fields[wv_field_index].base[raw_field_index][property] = value
        this.setState({...new_state}, () => console.log("Maping Fields to WV :", this.state))
      }
    }
  }

  renderFieldAttachmentSettings = () => {
    return (
      <Fragment>
        <FormControlLabel
          control={
            <Checkbox
              checked = {this.getFieldProperty(this.state.selected_wv_field, this.state.selected_raw_field, 'include_field_level_attachment')}
              name="checkedB"
              color="primary"
              onChange = {(event) => {
                this.setFieldProperty(
                  this.state.selected_wv_field, 
                  this.state.selected_raw_field, 
                  'include_field_level_attachment', 
                  this.getFieldProperty(this.state.selected_wv_field, this.state.selected_raw_field, 'include_field_level_attachment') ? false : true
                )
              }}
            />
          }
          label = "Include Field Attachments"
          labelPlacement = "end"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked = {this.getFieldProperty(this.state.selected_wv_field, this.state.selected_raw_field, 'include_value_with_embedded_attachment')}
              name="checkedB"
              color="primary"
              onChange = {(event) => {
                this.setFieldProperty(
                  this.state.selected_wv_field, 
                  this.state.selected_raw_field, 
                  'include_value_with_embedded_attachment', 
                  this.getFieldProperty(this.state.selected_wv_field, this.state.selected_raw_field, 'include_value_with_embedded_attachment') ? false : true
                )
              }}
            />
          }
          label = "Include Embedded Attachment Values"
          labelPlacement = "end"
        />
        <Autocomplete
          multiple
          id="tags-standard"
          options={this.state.file_types}
          getOptionLabel={(option) => option}
          value = {this.getFieldProperty(this.state.selected_wv_field, this.state.selected_raw_field, 'include_file_extensions')}
          disabled = {!this.getFieldProperty(this.state.selected_wv_field, this.state.selected_raw_field, 'include_field_level_attachment')}
          onChange={(event, newValue) => {
            this.setFieldProperty(
              this.state.selected_wv_field, 
              this.state.selected_raw_field, 
              'include_file_extensions', 
              newValue
            )
          }}
          ChipProps = {{size : 'small'}}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="File Types"
              size="small"
              helperText = "Accepted File Types. If nothing is selected, all supported file types will be processed."
            />
          )}
        />
      </Fragment>
    )
  }

  render() {
    const { classes } = this.props;
    return (
      <ThemeProvider theme = {blue_theme}>
      <Paper
        elevation={0}
        square
        style={{ width: "100%", height: "100%"}}
      >
        <div
          style={{
            width: "100%",
            height: this.props.maxHeight,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
          }}
        >
          <div
            style={{
              flexGrow: 0,
              borderBottom: "1px solid rgba(0,0,0,0.12)",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              padding : '8px'
            }}
          >
            <Typography style = {{flexGrow : 1}} variant="h6">Configure World View</Typography>
            {this.state.error === true ? (
              <Typography
                style={{
                  color: "#f44336",
                  marginBottom: "2px",
                  marginLeft: "10px",
                }}
                variant="caption"
              >
                <em>{this.state.error_text}</em>
              </Typography>
            ) : null}
            {this.props.submit && <Button
              variant="contained"
              color="primary"
              disabled={this.state.submit === false ? false : true}
              onClick={this.submitWorldViewMap}
            >
              Submit World View Map
            </Button>}
          </div>
          <Grid
            container
            style={{
              backgroundColor: "#F5F5F5",
              height: "100%",
              overflow: "auto",
            }}
            xs={12}
            direction="row"
          >
            {this.renderWorldViewList()}
            {this.state.selected_wv_field !== null ? this.renderMapArea() : null}
          </Grid>
        </div>
      </Paper>
      </ThemeProvider>
    );
  }
}

export default ConfigureWV;
